import React, { useCallback, useEffect, useState } from 'react';
import IntroReporting from './IntroReporting';
import { IntroBaseProps, IntroSteps } from './utils';
import IntroEliminate from './IntroEliminate';
import IntroInspire from './IntroInspire';
import IntroWelcome from './IntroWelcome';

const Intro: React.FC<IntroBaseProps> = ({ reportYear, handleClose }) => {
  const [steps, setSteps] = useState<IntroSteps>('welcome');

  const handleNextStep = useCallback(() => {
    setSteps(s => {
      switch (s) {
        case 'welcome':
          return 'eliminate';
        case 'eliminate':
          return 'inspire';
        case 'inspire':
          return 'reporting';
      }
      return s;
    });
  }, [setSteps]);

  switch (steps) {
    case 'eliminate':
      return (
        <IntroEliminate
          reportYear={reportYear}
          setSteps={setSteps}
          handleClose={handleClose}
          handleNextStep={handleNextStep}
        />
      );
    case 'inspire':
      return (
        <IntroInspire
          reportYear={reportYear}
          setSteps={setSteps}
          handleClose={handleClose}
          handleNextStep={handleNextStep}
        />
      );
    case 'reporting':
      return (
        <IntroReporting
          reportYear={reportYear}
          setSteps={setSteps}
          handleClose={handleClose}
          handleNextStep={handleNextStep}
        />
      );
    case 'welcome':
    default:
      return (
        <IntroWelcome
          reportYear={reportYear}
          setSteps={setSteps}
          handleClose={handleClose}
          handleNextStep={handleNextStep}
        />
      );
  }
};

export default Intro;
